var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("群組管理")]), _c('div', {
    staticClass: "borderColor mb-4"
  }, [_c('div', {
    staticClass: "d-flex m-2 mb-3"
  }, [_c('v-btn', {
    staticClass: "ml-auto",
    attrs: {
      "color": "primary",
      "depressed": "",
      "elevation": "2"
    },
    on: {
      "click": _vm.handleUpdateGroupData
    }
  }, [_vm._v(" 更新群組 ")])], 1), _c('div', {
    staticClass: "tableWrap"
  }, [_c('table', {
    staticClass: "text-center"
  }, [_c('tr', {
    staticClass: "sticky-top"
  }, [_vm._l(_vm.thTitle, function (tableTitle, thIdx) {
    return _c('th', {
      key: thIdx
    }, [_vm._v(" " + _vm._s(tableTitle) + " ")]);
  }), _c('th', [_vm._v("設定")])], 2), _vm._l(_vm.data, function (group, groupIdx) {
    return _c('tr', {
      key: groupIdx
    }, [_c('td', [_vm._v(_vm._s(group.role))]), _c('td', _vm._l(_vm.sideMenuOptions, function (item) {
      return _c('v-checkbox', {
        key: item.text,
        staticClass: "checkBox w-75",
        attrs: {
          "label": item.text,
          "value": item.value,
          "hide-details": ""
        },
        on: {
          "change": function change($event) {
            return _vm.sortSelectedSideMenu(groupIdx);
          }
        },
        model: {
          value: _vm.data[groupIdx].sideMenu,
          callback: function callback($$v) {
            _vm.$set(_vm.data[groupIdx], "sideMenu", $$v);
          },
          expression: "data[groupIdx].sideMenu"
        }
      });
    }), 1), _c('td', _vm._l(_vm.componentMenuOptions, function (compItem) {
      return _c('v-checkbox', {
        key: compItem.text,
        staticClass: "checkBox w-50",
        attrs: {
          "label": compItem.text,
          "value": compItem.value,
          "hide-details": ""
        },
        on: {
          "change": function change($event) {
            return _vm.sortSelectedComponentMenu(groupIdx);
          }
        },
        model: {
          value: _vm.data[groupIdx].componentMenu,
          callback: function callback($$v) {
            _vm.$set(_vm.data[groupIdx], "componentMenu", $$v);
          },
          expression: "data[groupIdx].componentMenu"
        }
      });
    }), 1), _c('td', _vm._l(_vm.data[groupIdx].othersMenu, function (obj, updateIdx) {
      var _obj$list, _obj$list2;
      return _c('div', {
        key: updateIdx,
        staticClass: "mb-5"
      }, [_c('v-checkbox', {
        staticClass: "checkBox mb-3",
        attrs: {
          "label": obj.menuName,
          "hide-details": ""
        },
        on: {
          "change": function change($event) {
            return _vm.handleSelectedOthersMenuTitle(obj.hasPermission, groupIdx, updateIdx);
          }
        },
        model: {
          value: obj.hasPermission,
          callback: function callback($$v) {
            _vm.$set(obj, "hasPermission", $$v);
          },
          expression: "obj.hasPermission"
        }
      }), _c('div', {
        staticClass: "section"
      }, [_c('span', [_vm._v(" " + _vm._s(_vm.othersMenuList[updateIdx].listName) + " : ")]), _c('v-select', {
        attrs: {
          "items": _vm.othersMenuList[updateIdx].options,
          "multiple": "",
          "outlined": "",
          "small-chips": "",
          "deletable-chips": "",
          "attach": "",
          "menu-props": {
            offsetY: true
          },
          "disabled": !(obj !== null && obj !== void 0 && obj.hasPermission),
          "placeholder": "請選擇",
          "error-messages": obj !== null && obj !== void 0 && obj.hasPermission && !(obj !== null && obj !== void 0 && (_obj$list = obj.list) !== null && _obj$list !== void 0 && _obj$list.length) ? ['請至少選擇一項'] : [],
          "error": (obj === null || obj === void 0 ? void 0 : obj.hasPermission) && !(obj !== null && obj !== void 0 && (_obj$list2 = obj.list) !== null && _obj$list2 !== void 0 && _obj$list2.length)
        },
        on: {
          "input": function input($event) {
            return _vm.sortSelectedOthersMenuList(groupIdx, updateIdx);
          }
        },
        model: {
          value: obj.list,
          callback: function callback($$v) {
            _vm.$set(obj, "list", $$v);
          },
          expression: "obj.list"
        }
      })], 1)], 1);
    }), 0), _c('td', [_c('v-dialog', {
      staticClass: "settingDialog",
      attrs: {
        "max-width": "1000px"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "settingButton my-5 d-none",
            attrs: {
              "depressed": "",
              "outlined": "",
              "block": ""
            }
          }, 'v-btn', attrs, false), on), [_vm._v(" 太陽能雲端監控 ")])];
        }
      }], null, true),
      model: {
        value: _vm.solarDialogs[groupIdx],
        callback: function callback($$v) {
          _vm.$set(_vm.solarDialogs, groupIdx, $$v);
        },
        expression: "solarDialogs[groupIdx]"
      }
    }, [_c('v-card', [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between p-4 pb-3"
    }, [_c('span', {
      staticClass: "text-h6"
    }, [_vm._v(" [ " + _vm._s(group.role) + " ] 太陽能雲端監控 ")]), _c('v-alert', {
      staticClass: "mb-0",
      attrs: {
        "type": "info",
        "color": "primary",
        "text": "",
        "dense": ""
      }
    }, [_vm._v(" 修改後，請更新群組 ")])], 1), _c('v-simple-table', {
      staticClass: "px-3 pb-2",
      attrs: {
        "dense": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn() {
          return [_c('thead', [_c('tr', [_c('th', {
            staticClass: "text-left w-25",
            staticStyle: {
              "font-size": "16px"
            }
          }, [_vm._v(" 可觀看 SIDE 網頁 ")]), _c('th', {
            staticClass: "text-left w-25",
            staticStyle: {
              "font-size": "16px"
            }
          }, [_vm._v(" 可觀看 TOP 網頁 ")]), _c('th', {
            staticClass: "text-left w-25",
            staticStyle: {
              "font-size": "16px"
            }
          }, [_vm._v(" 可使用項目 ")])])]), _c('tbody', [_c('tr', [_c('td', {
            staticClass: "pt-3 pb-4 align-top"
          }, _vm._l(_vm.sideMenuOptions, function (sideItem) {
            return _c('v-checkbox', {
              key: sideItem.text,
              staticClass: "checkBox",
              attrs: {
                "label": sideItem.text,
                "value": sideItem.value,
                "hide-details": ""
              },
              on: {
                "change": function change($event) {
                  return _vm.sortSelectedSideMenu(groupIdx);
                }
              },
              model: {
                value: _vm.data[groupIdx].sideMenu,
                callback: function callback($$v) {
                  _vm.$set(_vm.data[groupIdx], "sideMenu", $$v);
                },
                expression: "data[groupIdx].sideMenu"
              }
            });
          }), 1), _c('td', {
            staticClass: "pt-3 pb-4 align-top"
          }, _vm._l(_vm.componentMenuOptions, function (compItem) {
            return _c('v-checkbox', {
              key: compItem.text,
              staticClass: "checkBox",
              attrs: {
                "label": compItem.text,
                "value": compItem.value,
                "hide-details": ""
              },
              on: {
                "change": function change($event) {
                  return _vm.sortSelectedComponentMenu(groupIdx);
                }
              },
              model: {
                value: _vm.data[groupIdx].componentMenu,
                callback: function callback($$v) {
                  _vm.$set(_vm.data[groupIdx], "componentMenu", $$v);
                },
                expression: "data[groupIdx].componentMenu"
              }
            });
          }), 1), _c('td', {
            staticClass: "pt-3 pb-4 align-top"
          }, _vm._l(_vm.data[groupIdx].othersMenu, function (obj, updateIdx) {
            return _c('div', {
              key: updateIdx,
              staticClass: "mb-5"
            }, [_c('v-checkbox', {
              staticClass: "checkBox mb-3",
              attrs: {
                "label": obj.menuName,
                "hide-details": ""
              },
              on: {
                "change": function change($event) {
                  return _vm.handleSelectedOthersMenuTitle(obj.hasPermission, groupIdx, updateIdx);
                }
              },
              model: {
                value: obj.hasPermission,
                callback: function callback($$v) {
                  _vm.$set(obj, "hasPermission", $$v);
                },
                expression: "obj.hasPermission"
              }
            }), _c('div', {
              staticClass: "section"
            }, [_c('span', [_vm._v(" " + _vm._s(_vm.othersMenuList[updateIdx].listName) + " : ")]), _vm._l(_vm.othersMenuList[updateIdx].options, function (otherItem, otherItemIdx) {
              var _obj$list3;
              return _c('v-checkbox', {
                key: otherItem,
                staticClass: "checkBox",
                attrs: {
                  "label": otherItem,
                  "value": otherItem,
                  "disabled": !(obj !== null && obj !== void 0 && obj.hasPermission),
                  "error-messages": obj !== null && obj !== void 0 && obj.hasPermission && !(obj !== null && obj !== void 0 && (_obj$list3 = obj.list) !== null && _obj$list3 !== void 0 && _obj$list3.length) ? ['請至少選擇一項'] : [],
                  "hide-details": otherItemIdx !== _vm.othersMenuList[updateIdx].options.length - 1,
                  "dense": ""
                },
                on: {
                  "change": function change($event) {
                    return _vm.sortSelectedOthersMenuList(groupIdx, updateIdx);
                  }
                },
                model: {
                  value: obj.list,
                  callback: function callback($$v) {
                    _vm.$set(obj, "list", $$v);
                  },
                  expression: "obj.list"
                }
              });
            })], 2)], 1);
          }), 0)])])];
        },
        proxy: true
      }], null, true)
    })], 1)], 1), _c('v-dialog', {
      staticClass: "settingDialog",
      attrs: {
        "max-width": "600px"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref2) {
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "settingButton my-5",
            attrs: {
              "depressed": "",
              "outlined": "",
              "block": ""
            }
          }, 'v-btn', attrs, false), on), [_vm._v(" 電能可視化管理 ")])];
        }
      }], null, true),
      model: {
        value: _vm.energyDialogs[groupIdx],
        callback: function callback($$v) {
          _vm.$set(_vm.energyDialogs, groupIdx, $$v);
        },
        expression: "energyDialogs[groupIdx]"
      }
    }, [_c('v-card', [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between p-4 pb-3"
    }, [_c('span', {
      staticClass: "text-h6"
    }, [_vm._v("[ " + _vm._s(group.role) + " ] 電能可視化管理")]), _c('v-alert', {
      staticClass: "mb-0",
      attrs: {
        "type": "info",
        "color": "primary",
        "text": "",
        "dense": ""
      }
    }, [_vm._v(" 修改後，請更新群組 ")])], 1), _c('v-simple-table', {
      staticClass: "px-3 pb-2",
      attrs: {
        "dense": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn() {
          return [_c('thead', [_c('tr', [_c('th', {
            staticClass: "text-left w-50",
            staticStyle: {
              "font-size": "16px"
            }
          }, [_vm._v(" 可觀看 SIDE 網頁 ")])])]), _c('tbody', [_c('tr', [_c('td', {
            staticClass: "pt-3 pb-4"
          }, _vm._l(_vm.energySideMenuOptions, function (energyItem) {
            return _c('v-checkbox', {
              key: energyItem.text,
              staticClass: "checkBox",
              attrs: {
                "label": energyItem.text,
                "value": energyItem.value,
                "hide-details": ""
              },
              on: {
                "change": function change($event) {
                  return _vm.sortSelectedEnergySideMenu(groupIdx);
                }
              },
              model: {
                value: _vm.data[groupIdx].otherSites[0].sideMenu,
                callback: function callback($$v) {
                  _vm.$set(_vm.data[groupIdx].otherSites[0], "sideMenu", $$v);
                },
                expression: "data[groupIdx].otherSites[0].sideMenu"
              }
            });
          }), 1)])])];
        },
        proxy: true
      }], null, true)
    })], 1)], 1), _c('v-dialog', {
      staticClass: "settingDialog",
      attrs: {
        "max-width": "600px"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref3) {
          var on = _ref3.on,
            attrs = _ref3.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "settingButton d-block mx-auto my-5",
            attrs: {
              "depressed": "",
              "outlined": "",
              "block": ""
            }
          }, 'v-btn', attrs, false), on), [_vm._v(" 能源儀表板 ")])];
        }
      }], null, true),
      model: {
        value: _vm.roomDialogs[groupIdx],
        callback: function callback($$v) {
          _vm.$set(_vm.roomDialogs, groupIdx, $$v);
        },
        expression: "roomDialogs[groupIdx]"
      }
    }, [_c('v-card', [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between p-4 pb-3"
    }, [_c('span', {
      staticClass: "text-h6"
    }, [_vm._v("[ " + _vm._s(group.role) + " ] 能源儀表板")]), _c('v-alert', {
      staticClass: "mb-0",
      attrs: {
        "type": "info",
        "color": "primary",
        "text": "",
        "dense": ""
      }
    }, [_vm._v(" 修改後，請更新群組 ")])], 1), _c('v-simple-table', {
      staticClass: "px-3 pb-2",
      attrs: {
        "dense": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn() {
          return [_c('thead', [_c('tr', [_c('th', {
            staticClass: "text-left w-50",
            staticStyle: {
              "font-size": "16px"
            }
          }, [_vm._v(" 可觀看項目 ")])])]), _c('tbody', [_c('tr', [_c('td', {
            staticClass: "pt-3 pb-4"
          }, _vm._l(_vm.roomSideMenuOptions, function (roomItem) {
            return _c('v-checkbox', {
              key: roomItem.text,
              staticClass: "checkBox",
              attrs: {
                "label": roomItem.text,
                "value": roomItem.value,
                "hide-details": ""
              },
              on: {
                "change": function change($event) {
                  return _vm.sortSelectedRoomSideMenu(groupIdx);
                }
              },
              model: {
                value: _vm.data[groupIdx].otherSites[1].sideMenu,
                callback: function callback($$v) {
                  _vm.$set(_vm.data[groupIdx].otherSites[1], "sideMenu", $$v);
                },
                expression: "data[groupIdx].otherSites[1].sideMenu"
              }
            });
          }), 1)])])];
        },
        proxy: true
      }], null, true)
    })], 1)], 1), _c('v-dialog', {
      staticClass: "settingDialog",
      attrs: {
        "max-width": "600px"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref4) {
          var on = _ref4.on,
            attrs = _ref4.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "settingButton d-block mx-auto my-5",
            attrs: {
              "depressed": "",
              "outlined": "",
              "block": ""
            }
          }, 'v-btn', attrs, false), on), [_vm._v(" 其他監控來源 ")])];
        }
      }], null, true),
      model: {
        value: _vm.otherSourcesDialogs[groupIdx],
        callback: function callback($$v) {
          _vm.$set(_vm.otherSourcesDialogs, groupIdx, $$v);
        },
        expression: "otherSourcesDialogs[groupIdx]"
      }
    }, [_c('v-card', [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between p-4 pb-3"
    }, [_c('span', {
      staticClass: "text-h6"
    }, [_vm._v("[ " + _vm._s(group.role) + " ] 其他監控來源")]), _c('v-alert', {
      staticClass: "mb-0",
      attrs: {
        "type": "info",
        "color": "primary",
        "text": "",
        "dense": ""
      }
    }, [_vm._v(" 修改後，請更新群組 ")])], 1), _c('v-simple-table', {
      staticClass: "px-3 pb-2",
      attrs: {
        "dense": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn() {
          return [_c('thead', [_c('tr', [_c('th', {
            staticClass: "text-left w-50",
            staticStyle: {
              "font-size": "16px"
            }
          }, [_vm._v(" 可觀看項目 ")])])]), _c('tbody', [_c('tr', [_c('td', {
            staticClass: "pt-3 pb-4"
          }, _vm._l(_vm.otherSourcesSideMenuOptions, function (srcItem) {
            return _c('v-checkbox', {
              key: srcItem.text,
              staticClass: "checkBox",
              attrs: {
                "label": srcItem.text,
                "value": srcItem.value,
                "hide-details": ""
              },
              on: {
                "change": function change($event) {
                  return _vm.sortSelectedOtherSourcesSideMenu(groupIdx);
                }
              },
              model: {
                value: _vm.data[groupIdx].otherSites[2].sideMenu,
                callback: function callback($$v) {
                  _vm.$set(_vm.data[groupIdx].otherSites[2], "sideMenu", $$v);
                },
                expression: "data[groupIdx].otherSites[2].sideMenu"
              }
            });
          }), 1)])])];
        },
        proxy: true
      }], null, true)
    })], 1)], 1), _c('v-dialog', {
      staticClass: "settingDialog",
      attrs: {
        "max-width": "600px"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref5) {
          var on = _ref5.on,
            attrs = _ref5.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "settingButton d-block mx-auto my-5",
            attrs: {
              "depressed": "",
              "outlined": "",
              "block": ""
            }
          }, 'v-btn', attrs, false), on), [_vm._v(" 自主分析 ")])];
        }
      }], null, true),
      model: {
        value: _vm.selfAnalysisDialogs[groupIdx],
        callback: function callback($$v) {
          _vm.$set(_vm.selfAnalysisDialogs, groupIdx, $$v);
        },
        expression: "selfAnalysisDialogs[groupIdx]"
      }
    }, [_c('v-card', [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between p-4 pb-3"
    }, [_c('span', {
      staticClass: "text-h6"
    }, [_vm._v("[ " + _vm._s(group.role) + " ] 自主分析")]), _c('v-alert', {
      staticClass: "mb-0",
      attrs: {
        "type": "info",
        "color": "primary",
        "text": "",
        "dense": ""
      }
    }, [_vm._v(" 修改後，請更新群組 ")])], 1), _c('v-simple-table', {
      staticClass: "px-3 pb-2",
      attrs: {
        "dense": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn() {
          return [_c('thead', [_c('tr', [_c('th', {
            staticClass: "text-left w-50",
            staticStyle: {
              "font-size": "16px"
            }
          }, [_vm._v(" 可觀看項目 ")])])]), _c('tbody', [_c('tr', [_c('td', {
            staticClass: "pt-3 pb-4"
          }, _vm._l(_vm.selfAnalysisSideMenuOptions, function (srcItem) {
            return _c('v-checkbox', {
              key: srcItem.text,
              staticClass: "checkBox",
              attrs: {
                "label": srcItem.text,
                "value": srcItem.value,
                "hide-details": ""
              },
              on: {
                "change": function change($event) {
                  return _vm.sortSelectedSelfAnalysisSideMenu(groupIdx);
                }
              },
              model: {
                value: _vm.data[groupIdx].otherSites[3].sideMenu,
                callback: function callback($$v) {
                  _vm.$set(_vm.data[groupIdx].otherSites[3], "sideMenu", $$v);
                },
                expression: "data[groupIdx].otherSites[3].sideMenu"
              }
            });
          }), 1)])])];
        },
        proxy: true
      }], null, true)
    })], 1)], 1)], 1), _c('td', [_c('v-btn', {
      staticClass: "settingButton",
      attrs: {
        "color": "error",
        "depressed": "",
        "outlined": ""
      },
      on: {
        "click": function click($event) {
          return _vm.handleDeleteGroupData(group.role, group.id);
        }
      }
    }, [_vm._v(" 刪除群組 ")])], 1)]);
  }), _c('tr', [_c('td', [_c('v-text-field', {
    staticClass: "textInput w-75 mx-auto",
    attrs: {
      "label": "輸入等級名稱"
    },
    model: {
      value: _vm.createRoleName,
      callback: function callback($$v) {
        _vm.createRoleName = $$v;
      },
      expression: "createRoleName"
    }
  })], 1), _c('td', _vm._l(_vm.sideMenuOptions, function (item) {
    return _c('v-checkbox', {
      key: item.text,
      staticClass: "checkBox w-75",
      attrs: {
        "label": item.text,
        "value": item.value,
        "hide-details": ""
      },
      on: {
        "change": function change($event) {
          return _vm.sortSelectedSideMenu('createNew');
        }
      },
      model: {
        value: _vm.createSolarSideMenu,
        callback: function callback($$v) {
          _vm.createSolarSideMenu = $$v;
        },
        expression: "createSolarSideMenu"
      }
    });
  }), 1), _c('td', _vm._l(_vm.componentMenuOptions, function (compItem) {
    return _c('v-checkbox', {
      key: compItem.text,
      staticClass: "checkBox w-50",
      attrs: {
        "label": compItem.text,
        "value": compItem.value,
        "hide-details": ""
      },
      on: {
        "change": function change($event) {
          return _vm.sortSelectedComponentMenu('createNew');
        }
      },
      model: {
        value: _vm.createSolarComponentMenu,
        callback: function callback($$v) {
          _vm.createSolarComponentMenu = $$v;
        },
        expression: "createSolarComponentMenu"
      }
    });
  }), 1), _c('td', _vm._l(_vm.createSolarOthersMenu, function (createObj, createIdx) {
    var _createObj$list, _createObj$list2;
    return _c('div', {
      key: createIdx,
      staticClass: "mb-5"
    }, [_c('v-checkbox', {
      staticClass: "checkBox mb-3",
      attrs: {
        "label": createObj.menuName,
        "hide-details": ""
      },
      on: {
        "change": function change($event) {
          return _vm.handleSelectedOthersMenuTitle(createObj.hasPermission, 'createNew', createIdx);
        }
      },
      model: {
        value: createObj.hasPermission,
        callback: function callback($$v) {
          _vm.$set(createObj, "hasPermission", $$v);
        },
        expression: "createObj.hasPermission"
      }
    }), _c('div', {
      staticClass: "section"
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.othersMenuList[createIdx].listName) + " : ")]), _c('v-select', {
      attrs: {
        "items": _vm.othersMenuList[createIdx].options,
        "multiple": "",
        "outlined": "",
        "small-chips": "",
        "deletable-chips": "",
        "attach": "",
        "menu-props": {
          offsetY: true
        },
        "disabled": !(createObj !== null && createObj !== void 0 && createObj.hasPermission),
        "placeholder": "請選擇",
        "error-messages": createObj !== null && createObj !== void 0 && createObj.hasPermission && !(createObj !== null && createObj !== void 0 && (_createObj$list = createObj.list) !== null && _createObj$list !== void 0 && _createObj$list.length) ? ['請至少選擇一項'] : [],
        "error": (createObj === null || createObj === void 0 ? void 0 : createObj.hasPermission) && !(createObj !== null && createObj !== void 0 && (_createObj$list2 = createObj.list) !== null && _createObj$list2 !== void 0 && _createObj$list2.length)
      },
      on: {
        "input": function input($event) {
          return _vm.sortSelectedOthersMenuList('createNew', createIdx);
        }
      },
      model: {
        value: createObj.list,
        callback: function callback($$v) {
          _vm.$set(createObj, "list", $$v);
        },
        expression: "createObj.list"
      }
    })], 1)], 1);
  }), 0), _c('td', [_c('v-dialog', {
    staticClass: "settingDialog",
    attrs: {
      "max-width": "1000px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref6) {
        var on = _ref6.on,
          attrs = _ref6.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "settingButton my-5 d-none",
          attrs: {
            "depressed": "",
            "outlined": "",
            "block": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 太陽能管理 ")])];
      }
    }]),
    model: {
      value: _vm.createSolarDialog,
      callback: function callback($$v) {
        _vm.createSolarDialog = $$v;
      },
      expression: "createSolarDialog"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "p-4 pb-3 text-h6"
  }, [_vm._v(" [ " + _vm._s(_vm.createRoleName) + " ] 太陽能管理 ")]), _c('v-simple-table', {
    staticClass: "px-3 pb-2",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left w-25",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可觀看 SIDE 網頁 ")]), _c('th', {
          staticClass: "text-left w-25",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可觀看 TOP 網頁 ")]), _c('th', {
          staticClass: "text-left w-25",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可使用項目 ")])])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "pt-3 pb-4 align-top"
        }, _vm._l(_vm.solarSideMenuOptions, function (solarItem) {
          return _c('v-checkbox', {
            key: solarItem.text,
            staticClass: "checkBox",
            attrs: {
              "label": solarItem.text,
              "value": solarItem.value,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.sortSelectedSolarSideMenu('createNew');
              }
            },
            model: {
              value: _vm.createSolarSideMenu,
              callback: function callback($$v) {
                _vm.createSolarSideMenu = $$v;
              },
              expression: "createSolarSideMenu"
            }
          });
        }), 1), _c('td', {
          staticClass: "pt-3 pb-4 align-top"
        }, _vm._l(_vm.solarComponentMenuOptions, function (solarCompItem) {
          return _c('v-checkbox', {
            key: solarCompItem.text,
            staticClass: "checkBox",
            attrs: {
              "label": solarCompItem.text,
              "value": solarCompItem.value,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.sortSelectedSolarComponentMenu('createNew');
              }
            },
            model: {
              value: _vm.createSolarComponentMenu,
              callback: function callback($$v) {
                _vm.createSolarComponentMenu = $$v;
              },
              expression: "createSolarComponentMenu"
            }
          });
        }), 1), _c('td', {
          staticClass: "pt-3 pb-4 align-top"
        }, _vm._l(_vm.createSolarOthersMenu, function (createObj, createIdx) {
          return _c('div', {
            key: createIdx,
            staticClass: "mb-5"
          }, [_c('v-checkbox', {
            staticClass: "checkBox mb-3",
            attrs: {
              "label": createObj.menuName,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.handleSelectedOthersMenuTitle(createObj.hasPermission, 'createNew', createIdx);
              }
            },
            model: {
              value: createObj.hasPermission,
              callback: function callback($$v) {
                _vm.$set(createObj, "hasPermission", $$v);
              },
              expression: "createObj.hasPermission"
            }
          }), _c('div', {
            staticClass: "section"
          }, [_c('span', [_vm._v(" " + _vm._s(_vm.othersMenuList[createIdx].listName) + " : ")]), _vm._l(_vm.othersMenuList[createIdx].options, function (createOtherItem, createOtherItemIdx) {
            var _createObj$list3;
            return _c('v-checkbox', {
              key: createOtherItem,
              staticClass: "checkBox",
              attrs: {
                "label": createOtherItem,
                "value": createOtherItem,
                "disabled": !(createObj !== null && createObj !== void 0 && createObj.hasPermission),
                "error-messages": createObj !== null && createObj !== void 0 && createObj.hasPermission && !(createObj !== null && createObj !== void 0 && (_createObj$list3 = createObj.list) !== null && _createObj$list3 !== void 0 && _createObj$list3.length) ? ['請至少選擇一項'] : [],
                "hide-details": createOtherItemIdx !== _vm.othersMenuList[createIdx].options.length - 1,
                "dense": ""
              },
              on: {
                "change": function change($event) {
                  return _vm.sortSelectedOthersMenuList('createNew', createIdx);
                }
              },
              model: {
                value: createObj.list,
                callback: function callback($$v) {
                  _vm.$set(createObj, "list", $$v);
                },
                expression: "createObj.list"
              }
            });
          })], 2)], 1);
        }), 0)])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-dialog', {
    staticClass: "settingDialog",
    attrs: {
      "max-width": "1000px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref7) {
        var on = _ref7.on,
          attrs = _ref7.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "settingButton my-5 d-none",
          attrs: {
            "depressed": "",
            "outlined": "",
            "block": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 太陽能雲端監控 ")])];
      }
    }]),
    model: {
      value: _vm.createSolarDialog,
      callback: function callback($$v) {
        _vm.createSolarDialog = $$v;
      },
      expression: "createSolarDialog"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "p-4 pb-3 text-h6"
  }, [_vm._v(" [ " + _vm._s(_vm.createRoleName) + " ] 太陽能雲端監控 ")]), _c('v-simple-table', {
    staticClass: "px-3 pb-2",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left w-25",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可觀看 SIDE 網頁 ")]), _c('th', {
          staticClass: "text-left w-25",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可觀看 TOP 網頁 ")]), _c('th', {
          staticClass: "text-left w-25",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可使用項目 ")])])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "pt-3 pb-4 align-top"
        }, _vm._l(_vm.sideMenuOptions, function (solarItem) {
          return _c('v-checkbox', {
            key: solarItem.text,
            staticClass: "checkBox",
            attrs: {
              "label": solarItem.text,
              "value": solarItem.value,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.sortSelectedSideMenu('createNew');
              }
            },
            model: {
              value: _vm.createSolarSideMenu,
              callback: function callback($$v) {
                _vm.createSolarSideMenu = $$v;
              },
              expression: "createSolarSideMenu"
            }
          });
        }), 1), _c('td', {
          staticClass: "pt-3 pb-4 align-top"
        }, _vm._l(_vm.componentMenuOptions, function (compItem) {
          return _c('v-checkbox', {
            key: compItem.text,
            staticClass: "checkBox",
            attrs: {
              "label": compItem.text,
              "value": compItem.value,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.sortSelectedComponentMenu('createNew');
              }
            },
            model: {
              value: _vm.createSolarComponentMenu,
              callback: function callback($$v) {
                _vm.createSolarComponentMenu = $$v;
              },
              expression: "createSolarComponentMenu"
            }
          });
        }), 1), _c('td', {
          staticClass: "pt-3 pb-4 align-top"
        }, _vm._l(_vm.createSolarOthersMenu, function (createObj, createIdx) {
          return _c('div', {
            key: createIdx,
            staticClass: "mb-5"
          }, [_c('v-checkbox', {
            staticClass: "checkBox mb-3",
            attrs: {
              "label": createObj.menuName,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.handleSelectedOthersMenuTitle(createObj.hasPermission, 'createNew', createIdx);
              }
            },
            model: {
              value: createObj.hasPermission,
              callback: function callback($$v) {
                _vm.$set(createObj, "hasPermission", $$v);
              },
              expression: "createObj.hasPermission"
            }
          }), _c('div', {
            staticClass: "section"
          }, [_c('span', [_vm._v(" " + _vm._s(_vm.othersMenuList[createIdx].listName) + " : ")]), _vm._l(_vm.othersMenuList[createIdx].options, function (createOtherItem, createOtherItemIdx) {
            var _createObj$list4;
            return _c('v-checkbox', {
              key: createOtherItem,
              staticClass: "checkBox",
              attrs: {
                "label": createOtherItem,
                "value": createOtherItem,
                "disabled": !(createObj !== null && createObj !== void 0 && createObj.hasPermission),
                "error-messages": createObj !== null && createObj !== void 0 && createObj.hasPermission && !(createObj !== null && createObj !== void 0 && (_createObj$list4 = createObj.list) !== null && _createObj$list4 !== void 0 && _createObj$list4.length) ? ['請至少選擇一項'] : [],
                "hide-details": createOtherItemIdx !== _vm.othersMenuList[createIdx].options.length - 1,
                "dense": ""
              },
              on: {
                "change": function change($event) {
                  return _vm.sortSelectedOthersMenuList('createNew', createIdx);
                }
              },
              model: {
                value: createObj.list,
                callback: function callback($$v) {
                  _vm.$set(createObj, "list", $$v);
                },
                expression: "createObj.list"
              }
            });
          })], 2)], 1);
        }), 0)])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-dialog', {
    staticClass: "settingDialog",
    attrs: {
      "max-width": "600px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref8) {
        var on = _ref8.on,
          attrs = _ref8.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "settingButton my-5",
          attrs: {
            "depressed": "",
            "outlined": "",
            "block": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 電能可視化管理 ")])];
      }
    }]),
    model: {
      value: _vm.createEnergyDialog,
      callback: function callback($$v) {
        _vm.createEnergyDialog = $$v;
      },
      expression: "createEnergyDialog"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "p-4 pb-3 text-h6"
  }, [_vm._v(" [ " + _vm._s(_vm.createRoleName) + " ] 電能可視化管理 ")]), _c('v-simple-table', {
    staticClass: "px-3 pb-2",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left w-50",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可觀看 SIDE 網頁 ")])])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "pt-3 pb-4"
        }, _vm._l(_vm.energySideMenuOptions, function (energyItem) {
          return _c('v-checkbox', {
            key: energyItem.text,
            staticClass: "checkBox",
            attrs: {
              "label": energyItem.text,
              "value": energyItem.value,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.sortSelectedEnergySideMenu('createNew');
              }
            },
            model: {
              value: _vm.createEnergySideMenu,
              callback: function callback($$v) {
                _vm.createEnergySideMenu = $$v;
              },
              expression: "createEnergySideMenu"
            }
          });
        }), 1)])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-dialog', {
    staticClass: "settingDialog",
    attrs: {
      "max-width": "600px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref9) {
        var on = _ref9.on,
          attrs = _ref9.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "settingButton my-5",
          attrs: {
            "depressed": "",
            "outlined": "",
            "block": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 能源儀表板 ")])];
      }
    }]),
    model: {
      value: _vm.createRoomDialog,
      callback: function callback($$v) {
        _vm.createRoomDialog = $$v;
      },
      expression: "createRoomDialog"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "p-4 pb-3 text-h6"
  }, [_vm._v(" [ " + _vm._s(_vm.createRoleName) + " ] 能源儀表板 ")]), _c('v-simple-table', {
    staticClass: "px-3 pb-2",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left w-50",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可觀看項目 ")])])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "pt-3 pb-4"
        }, _vm._l(_vm.roomSideMenuOptions, function (roomItem) {
          return _c('v-checkbox', {
            key: roomItem.text,
            staticClass: "checkBox",
            attrs: {
              "label": roomItem.text,
              "value": roomItem.value,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.sortSelectedRoomSideMenu('createNew');
              }
            },
            model: {
              value: _vm.createRoomSideMenu,
              callback: function callback($$v) {
                _vm.createRoomSideMenu = $$v;
              },
              expression: "createRoomSideMenu"
            }
          });
        }), 1)])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-dialog', {
    staticClass: "settingDialog",
    attrs: {
      "max-width": "600px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref10) {
        var on = _ref10.on,
          attrs = _ref10.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "settingButton my-5",
          attrs: {
            "depressed": "",
            "outlined": "",
            "block": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 其他監控來源 ")])];
      }
    }]),
    model: {
      value: _vm.createOtherSourcesDialog,
      callback: function callback($$v) {
        _vm.createOtherSourcesDialog = $$v;
      },
      expression: "createOtherSourcesDialog"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "p-4 pb-3 text-h6"
  }, [_vm._v(" [ " + _vm._s(_vm.createRoleName) + " ] 其他監控來源 ")]), _c('v-simple-table', {
    staticClass: "px-3 pb-2",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left w-50",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可觀看項目 ")])])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "pt-3 pb-4"
        }, _vm._l(_vm.otherSourcesSideMenuOptions, function (srcItem) {
          return _c('v-checkbox', {
            key: srcItem.text,
            staticClass: "checkBox",
            attrs: {
              "label": srcItem.text,
              "value": srcItem.value,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.sortSelectedOtherSourcesSideMenu('createNew');
              }
            },
            model: {
              value: _vm.createOtherSourcesSideMenu,
              callback: function callback($$v) {
                _vm.createOtherSourcesSideMenu = $$v;
              },
              expression: "createOtherSourcesSideMenu"
            }
          });
        }), 1)])])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-dialog', {
    staticClass: "settingDialog",
    attrs: {
      "max-width": "600px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref11) {
        var on = _ref11.on,
          attrs = _ref11.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "settingButton my-5",
          attrs: {
            "depressed": "",
            "outlined": "",
            "block": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 自主分析 ")])];
      }
    }]),
    model: {
      value: _vm.createSelfAnalysisDialog,
      callback: function callback($$v) {
        _vm.createSelfAnalysisDialog = $$v;
      },
      expression: "createSelfAnalysisDialog"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "p-4 pb-3 text-h6"
  }, [_vm._v(" [ " + _vm._s(_vm.createRoleName) + " ] 自主分析 ")]), _c('v-simple-table', {
    staticClass: "px-3 pb-2",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left w-50",
          staticStyle: {
            "font-size": "16px"
          }
        }, [_vm._v(" 可觀看項目 ")])])]), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "pt-3 pb-4"
        }, _vm._l(_vm.selfAnalysisSideMenuOptions, function (srcItem) {
          return _c('v-checkbox', {
            key: srcItem.text,
            staticClass: "checkBox",
            attrs: {
              "label": srcItem.text,
              "value": srcItem.value,
              "hide-details": ""
            },
            on: {
              "change": function change($event) {
                return _vm.sortSelectedSelfAnalysisSideMenu('createNew');
              }
            },
            model: {
              value: _vm.createSelfAnalysisSideMenu,
              callback: function callback($$v) {
                _vm.createSelfAnalysisSideMenu = $$v;
              },
              expression: "createSelfAnalysisSideMenu"
            }
          });
        }), 1)])])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _c('td', [_c('v-btn', {
    staticClass: "settingButton",
    attrs: {
      "color": "primary",
      "depressed": "",
      "outlined": ""
    },
    on: {
      "click": _vm.handleCreateGroupData
    }
  }, [_vm._v(" 新增群組 ")])], 1)])], 2)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };